import { FC, PropsWithChildren } from 'react';

import './style.scss';

export const VideoWrapper: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  return <div className="article-video-wrapper">{children}</div>;
};
